import { lotteryAdminTypes, lotteryRestShowTypes } from 'config/promoLotteryTypes';

export default function getLotteryCardRemainderInfo(lotteryData = {}, lotteryPrizes = []) {
    const { showRest, remainder, prizeLimited, type } = lotteryData;
    let quantityInfo = {};

    if (type !== lotteryAdminTypes.ADMIN && prizeLimited) {
        if (showRest === lotteryRestShowTypes.SHOW_REMAIN_AMOUNT) {
            quantityInfo.prizeLeftQuantity = remainder;
        } else if (showRest === lotteryRestShowTypes.SHOW_TOTAL_AMOUNT) {
            const total = lotteryPrizes.reduce((t, p) => {
                const {
                    isLimited,
                    settings: { quantity = 0 }
                } = p;
                const count = Boolean(isLimited) ? quantity : 0;
                return t + count;
            }, 0);
            quantityInfo.prizeTotalQuantity = total;
        }
    }

    return quantityInfo;
}
